export default "__VITE_ASSET__Bh1UPwJA__"